import ApplicationSelector from "./ApplicationSelector";

export default ApplicationSelector;